import { toast } from 'react-toastify/unstyled';

import { CopyToClipboard } from '@shared/icons';

import { IconButton } from './IconButton';

export interface GenericCopyToClipboardProps {
  text: string;
  tooltip?: string;
  successMessage?: string;
  className?: string;
  'data-testid'?: string;
}

export const GenericCopyToClipboard = ({
  text,
  tooltip = 'Copy to clipboard',
  successMessage = 'Copied to clipboard',
  className,
  'data-testid': dataTestId,
}: GenericCopyToClipboardProps) => {
  const handleCopy = () => {
    void navigator.clipboard.writeText(text).then(() => {
      toast.success(successMessage);
      return void 0;
    });
  };

  return (
    <IconButton
      icon={CopyToClipboard}
      tooltip={tooltip}
      onClick={handleCopy}
      className={className}
      data-testid={dataTestId}
    />
  );
};
